import * as types from '../types/index'
import axios from 'axios'
import toast from 'react-hot-toast'
import config from '../config'
import { authHeader, header } from '../headers'
import { admin_logout } from './adminAuthActions'
import { user_logout } from './userAuthActions'

const url = config.testUrl

export const create_campaign = (obj) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.CAMPAIGN_CREATE_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.post(`${url}/funding-rounds`, obj, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.CAMPAIGN_CREATE_SUCCESS,
				payload: data.data,
			})
			toast.success('Campaign has been created!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.CAMPAIGN_CREATE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const get_current_campaign_user = () => async (dispatch) => {
	try {
		dispatch({ type: types.GET_CURRENT_CAMPAIGN_REQUEST })

		const { data } = await axios.get(`${url}/funding-rounds/current`, {
			headers: header,
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_CURRENT_CAMPAIGN_SUCCESS,
				payload: data.data,
			})
			// toast.success('Campaign has been created!', {
			// 	position: 'top-right',
			// })
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'

		dispatch({ type: types.GET_CURRENT_CAMPAIGN_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const get_single_campaign = (slug) => async (dispatch) => {
	try {
		dispatch({ type: types.GET_CAMPAIGN_DETAILS_REQUEST })

		const { data } = await axios.get(`${url}/funding-rounds/${slug}`, {
			headers: header,
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_CAMPAIGN_DETAILS_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'

		dispatch({
			type: types.GET_CAMPAIGN_DETAILS_FAIL,
			payload: message,
		})
		toast.error(message, { position: 'top-right' })
	}
}

export const get_all_campaigns = () => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_ALL_CAMPAIGNS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		let link = `${url}/funding-rounds`

		const { data } = await axios.get(link, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_ALL_CAMPAIGNS_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.GET_ALL_CAMPAIGNS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const update_campaign = (slug, obj) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.put(`${url}/funding-rounds/${slug}`, obj, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.UPDATE_CAMPAIGN_DETAILS_SUCCESS,
				payload: data.data,
			})
			toast.success('Campaign has been updated!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.UPDATE_CAMPAIGN_DETAILS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const update_campaign_status = (slug) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.UPDATE_CAMPAIGN_STATUS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.put(
			`${url}/funding-rounds/status/`,
			{ slug },
			{
				headers: authHeader(detail.token),
			}
		)

		if (data.status === 'ok') {
			dispatch({
				type: types.UPDATE_CAMPAIGN_STATUS_SUCCESS,
				payload: data.data,
			})
			toast.success('Campaign status has been updated!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.UPDATE_CAMPAIGN_STATUS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}
